package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.update_restaurant_data


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class UpdateRestaurantModel(
    @SerialName("data")
    val data: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)